module.exports = "/_next/static/resources/woman-2-32d5235173d58546f3535e1577b76c4d.jpg";